import { isGeorgia } from "../../../../../src/utils/helpers/isGeorgia";

export const cityOrVillage = [
  {
    referenceId: 1,
    referenceNameEn: "City",
    referenceNameGe: "ქალაქი",
  },
  {
    referenceId: 2,
    referenceNameEn: "Village",
    referenceNameGe: "სოფელი",
  },
];
export function isCity(value) {
  return +value === 1;
}

export const ContactInfoChangeOptions = {
  PhoneNumber: {
    id: 0,
    title: "mobileNumber",
  },
  Email: {
    id: 1,
    title: "EmailAddress",
  },
  ActualAddress: {
    id: 2,
    title: "legalAddressFilled",
  },
};

export const fieldNames = {
  NAME_OF_COMPANY: "nameOfCompany",
  DIRECTOR_FULL_NAME: "directorFullName",
  IDENTIFICATION_NUMBER: "IdentificationNumber",
  LEGAL_FORM: "legalForm",
  CITY: "city",
  COUNTRY_CODE: "countryCode",
  COUNTRY: "country",
  CITY_VILLAGE: "cityVillage",
  APARTMENT_NUMBER: "apartmentNumber",
  HOME_NUMBER: "homeNumber",
  STREET: "street",
  // HOME_NUMBER: "homeNumber",
  IS_CITY: "isCity",
  VILLAGE: "village",
  IS_ACTUAL_ADDRESS: "isActualAddress",
  LEGAL_ADDRESS: "legal_address",
  ACTUAL_ADDRESS: "actual_address",
  FIRSTNAME: "FirstName",
  LASTNAME: "lastname",
  CITY_ID: "city",
  CITIZENSHIP: "citizenship",
  COUNTRYOFBIRTH: "countryofbirth",
  CITYOFBIRTH: "cityofbirth",
  DATEOFBIRTH: "dateofbirth",
  CONTACT_INFO_CHANGE_CHECKBOXES: "ContactInfoChangeCheckboxes",
  CONFIRMATION_STATUS: "ConfirmationStatus",
  AGREEMENT_HTML_BASED_ON_STEP_THREE: "agreementHTMLForConfirmation",
};

// function returns true if we have address.actualAddress.country and address.Actualaddress.homeNUmber
export function doWeHaveActualAddress(address) {
  const { [fieldNames.ACTUAL_ADDRESS]: actualAddress } = address;
  if (!actualAddress) return false;
  const { [fieldNames.COUNTRY]: country } = actualAddress;

  return !!country;
}

export function isContentGeorgian(lang) {
  return lang === "ka";
}

export function withNameSpace(namespace, fieldName) {
  return namespace ? `${namespace}.${fieldName}` : fieldName;
}

export function withTwoNameSpaces(namespace, secondName, fieldName) {
  return namespace ? `${namespace}.${secondName}.${fieldName}` : fieldName;
}

export function moveGeorgiaUp(data) {
  return data.sort(({ referenceId }) => {
    if (isGeorgia(referenceId)) {
      return -1;
    }
    return 1;
  });
}
